import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    marginBottom: -14,
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
  // Assinatura discreta do produto — único elemento memorável do passe
  // visual v2, o resto (shape, densidade, header) fica quieto de propósito.
  // Só aparece com a sidebar aberta (não cabe no rail de 72px colapsado).
  signature: {
    marginLeft: 24,
    marginTop: 4,
    fontFamily: '"JetBrains Mono", monospace',
    fontWeight: 500,
    fontSize: '0.65rem',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: '#f07575',
    whiteSpace: 'nowrap',
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
      {isOpen && <span className={classes.signature}>Yggdrasil</span>}
    </div>
  );
};
